// extracted by mini-css-extract-plugin
export default {"kTextbox":"AgriculturalUseCategoriesOfLandTable_kTextbox__1mjS5","GreyedOut":"AgriculturalUseCategoriesOfLandTable_GreyedOut__EAEEE"};